import { BaseEntity, BaseSearchForm } from 'entities'
import { Dna } from './dna'
import { PcrProcessLog } from './pcr_process_log'
import { PcrProtocol } from './pcr_protocol'
import { Probe } from './probe'
import { ProbeStock } from './probe_stock'
import { ProductItem } from './product_item'
import { User } from './user'

export type PcrRunProbes = {
    probe?: Probe
    probeStock?: ProbeStock
    sortNumber?: number
    probeStockId?: number
    isUsedStock?: boolean
    note?: string
}

export type PcrRunProbesForm = PcrRunProbes & {
    pcrRunId?: number
    probeId?: number
    probeStockId?: number
}

export type PcrRunStatus = 'NOT_STARTED' | 'RERUN' | 'FAILURE' | 'COMPLETED'
export type PcrRun = BaseEntity & {
    runId?: string
    pcrRunProbes?: PcrRunProbes[]
    dnaSet?: Dna[]
    pcrProtocol?: PcrProtocol
    pcrProtocolId?: number
    pcrStudyId?: number
    user?: User
    userId?: number
    rawData?: string | File
    isManual?: boolean
    standardDna?: Dna
    standardDnaId?: number
    masterMix?: string
    masterMixLot?: string
    pcrProcessLogs?: PcrProcessLog[]
    status?: PcrRunStatus
    productItems?: ProductItem[]
    pcrErrorCount?: number
    isXr?: boolean
    probes?: Probe[]
    note?: string
    equipmentType?: string
    dispenser?: string
    dispenserChip?: string
    errorNote?: string

    masterMixReagentItemId?: number
    pcrFreeWaterReagentItemId?: number
}

export type PcrRunForm = PcrRun & {
    probeIds?: number[]
    dnaIds?: number[]
}

export type PcrRunSearchForm = BaseSearchForm &
    PcrRun & {
        ordering?: string
    }

export const PROBE_COLORS = [
    '#448AFF',
    '#FFE082',
    '#81D4FA',
    '#C5E1A5',
    '#9575CD',
    '#FF80AB',
    '#349632',
    '#FFB74D',
    '#EC407A',
    '#4DD0E1',
    '#867596',
    '#983467',
    '#A1887F',
    '#CE93D8',
    '#78909C',
    '#E57373',
    '#AB47BC',
    '#90CAF9',
    '#EF9A9A',
    '#B2EBF2',
    '#769385',
    '#FFEA00',
    '#E64A19',
    '#76FF03',
    '#00E5FF',
    '#FFD54F',
    '#7C4DFF',
    '#E6EE9C',
    '#82B1FF',
    '#FF8A65',
    '#FFCC80',
    '#F8BBD0',
]

export const PCR_RUN_STATUS = ['NOT_STARTED', 'RERUN', 'FAILURE', 'COMPLETED']

export const PCR_RUN_STATUS_JP = ['未実行', '再測定', '失敗', '完了']
export const PCR_RUN_STATUS_SELECT_ITEMS = PCR_RUN_STATUS.map((value, index) => {
    return { label: PCR_RUN_STATUS_JP[index], value: value }
})
